{
 "_note": "Typisches Gewicht eines Stücks, so wie es eingekauft wird, je Produkt (Kennung aus catalog.json); unit ist das Wort für ein Stück. byName: abweichendes Gewicht für einen Namen des Produkts (Eigelb beim Ei). Gepflegt hier seit 22.10.2026; übernommen aus SpeisePlan (source). Startwerte, mit Erfahrung anpassen.",
 "source": {"repo":"martin-zur/lunchplan","commit":"cc4f3b0"},
 "pieces": {
  "zwiebel": {"grams":120,"unit":"Stk","byName":{"Gemüsezwiebel":{"grams":250,"unit":"Stk"}}},
  "schalotte": {"grams":30,"unit":"Stk"},
  "knoblauch": {"grams":5,"unit":"Zehe"},
  "tomate": {"grams":120,"unit":"Stk"},
  "paprika": {"grams":180,"unit":"Stk"},
  "zucchini": {"grams":200,"unit":"Stk"},
  "aubergine": {"grams":300,"unit":"Stk"},
  "karotte": {"grams":80,"unit":"Stk"},
  "kartoffel": {"grams":150,"unit":"Stk"},
  "lauch": {"grams":250,"unit":"Stange"},
  "gurke": {"grams":400,"unit":"Stk"},
  "fenchel": {"grams":250,"unit":"Stk"},
  "avocado": {"grams":200,"unit":"Stk"},
  "zitrone": {"grams":120,"unit":"Stk"},
  "limette": {"grams":70,"unit":"Stk"},
  "romanasalat": {"grams":350,"unit":"Kopf","byName":{"Romanasalatherzen":{"grams":150,"unit":"Stk"}}},
  "kopfsalat": {"grams":300,"unit":"Kopf"},
  "eisbergsalat": {"grams":500,"unit":"Kopf"},
  "apfel": {"grams":150,"unit":"Stk"},
  "chili": {"grams":15,"unit":"Stk"},
  "ingwer": {"grams":50,"unit":"Stk"},
  "ei": {"grams":60,"unit":"Stk","byName":{"Eigelb":{"grams":20,"unit":"Stk"},"Eiklar":{"grams":35,"unit":"Stk"},"Eiweiß":{"grams":35,"unit":"Stk"}}}
 }
}
